<template>
    <div v-if="(!task.omitted) || showOmitted ">
        <!-- Task Header. -->
        <div class="flex items-center mb-0 mt-2">
            <div class="w-6 flex-shrink-0">
            </div>
            <div class="w-16">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    :class="task.omitted?'text-red-600 line-through':'text-gray-900'"
                    v-text="task.reference"
                ></div>
            </div>
            <div class="flex-1 ml-0">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    :class="task.omitted?'text-red-600 line-through':'text-gray-900'"
                    v-text="task.name"
                ></div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>
        <cost-plan-item v-for="item in task.items"
                                :cost-plan="costPlan"
                                :showItemProgress="showItemProgress"
                                :show-omitted="showOmitted"
                                :key="item.id"
                                :readonly="readonly || task.omitted"
                                :currentItem="currentItem"
                                @updated="$emit('updated')"
                                @toggleBuildup="(i) => $emit('toggleBuildup',i)"
                                :latest-progress-report="latestProgressReport"
                                :section="section" :task="task"
                                :item="item" :ref="(readonly?'readonly-':'')+'items'"></cost-plan-item>
    </div>
</template>

<script>

import CostPlanItem from "./CostPlanItem.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import ContractedWorksSection from "../contracted-works/ContractedWorksSection.vue";

export default {
    components: {
        ContractedWorksSection,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
        CostPlanItem,
    },
    props: {
        costPlan: Object,
        section: Object,
        task: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        currentItem: null,
        readonly: true,
        latestProgressReport: Object,
    },
    data() {
        return {}
    },
    methods: {
        getBGClass() {
            if (this.task.omitted) {
                return ' bg-red-50';
            }
            return ' bg-white';
        },
    },
}
</script>
